import { Skeleton } from "@mui/material";
import { TextField as MUITextField } from "@mui/material";

// Rename your custom component to avoid conflict
const TextField = (props) => {
  if (props.loading) {
    return <Skeleton height="54px" width="100%" />;
  }
  return <MUITextField {...props}>{props.children}</MUITextField>;
};

export default TextField;
